import { render } from "./Tasks.vue?vue&type=template&id=67cd29cf&scoped=true"
import script from "./Tasks.vue?vue&type=script&lang=ts"
export * from "./Tasks.vue?vue&type=script&lang=ts"

import "./Tasks.vue?vue&type=style&index=0&id=67cd29cf&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-67cd29cf"

export default script